<div class="filter">
  <form #form="ngForm">
    <div class="filter-container row">
      <div class="form-group col-sm-2 col-md-2 col-lg-2">
        <label>From</label>
        <kendo-datetimepicker
          class="umj-datepicker-sm"
          [readonly]="disabled"
          [(ngModel)]="filter.Start"
          [focusedDate]="filter.Start"
          style="width: 100%"
          #fromDate="ngModel"
          name="fromDate"
          required
        >
        </kendo-datetimepicker>
      </div>
      <div class="form-group col-sm-2 col-md-2 col-lg-2">
        <label>To</label>
        <kendo-datetimepicker
          class="umj-datepicker-sm"
          [readonly]="disabled"
          [(ngModel)]="filter.End"
          [focusedDate]="filter.End"
          style="width: 100%"
          #toDate="ngModel"
          name="toDate"
          required
        >
        </kendo-datetimepicker>
      </div>
      <div class="form-group" [ngClass]="mode == 'agent' ? 'col-sm-1' : 'col-sm-2'">
        <label>Day of week</label>
        <kendo-dropdownlist
          [data]="days"
          [(value)]="filter.DayOfWeek"
          [filterable]="true"
          (filterChange)="handleDaysFilter($event)"
          [textField]="'Name'"
          [valueField]="'Id'"
          [defaultItem]="{ Id: null, Name: 'Select day...' }"
          class="dropdown-block form-control-sm"
          [disabled]="disabled"
          [valuePrimitive]="true"
        >
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-sm-3" *ngIf="mode != 'agent' && displayLocations">
        <label>Location</label>
        <kendo-multiselect
          class="form-control-sm form-control"
          [data]="filteredLocations"
          [(ngModel)]="filter.LotIds"
          name="location"
          [textField]="'LotName'"
          [valueField]="'Id'"
          [valuePrimitive]="true"
          [autoClose]="false"
          [filterable]="true"
          (filterChange)="handleLocationsFilter($event)"
          placeholder="Select locations..."
          [tagMapper]="tagMapper"
          [disabled]="disabled"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <input type="checkbox" class="k-checkbox k-checkbox-md k-rounded-md" [checked]="isLocationSelected(dataItem.Id)" />
            <label
              class="k-checkbox-label"
              style="margin-left: 8px; cursor: pointer"
              [style.font-style]="dataItem.Archived || dataItem.Disabled ? 'italic' : 'normal'"
            >
              {{ dataItem.LotName }} {{ dataItem.Archived ? '(Archived)' : dataItem.Disabled ? '(Disabled)' : '' }}
            </label>
          </ng-template>

          <ng-template kendoMultiSelectTagTemplate let-dataItem>
            <span class="custom-summary-text" *ngIf="dataItem.length">
              {{ dataItem.length }} locations selected
            </span>

            <span class="custom-summary-text" *ngIf="!dataItem.length">
              {{ dataItem.LotName }}
            </span>
          </ng-template>
        </kendo-multiselect>
      </div>

      <div class="form-group col-sm-2" *ngIf="mode == 'agent' && !skypeAgentEmail && displayAgents">
        <label>Agent</label>
        <kendo-dropdownlist
          [data]="filteredAgents"
          [(value)]="filter.SipAddress"
          [filterable]="true"
          (filterChange)="handleAgentsFilter($event)"
          [textField]="'Name'"
          [valueField]="'SIP'"
          [defaultItem]="{ SIP: null, Name: 'Select agent...' }"
          [disabled]="disabled"
          [valuePrimitive]="true"
          class="dropdown-block form-control-sm"
        >
        </kendo-dropdownlist>
      </div>

      <div class="form-group col-sm-1">
        <label>Incident Id</label>
        <input
          type="number"
          class="form-control form-control-sm"
          [(ngModel)]="filter.IncidentId"
          name="incidentId"
          [disabled]="disabled || filter.RandomSampleEnabled"
        />
      </div>

      <div class="form-group col-sm-1 random-sample-switch-group" *ngIf="mode == 'agent'">
        <label>Random selection</label>
        <button type="button" class="random-sample-toggle" [disabled]="disabled" (click)="toggleRandomSample(!filter.RandomSampleEnabled)">
          <i class="fa" [ngClass]="filter.RandomSampleEnabled ? 'fa-toggle-on' : 'fa-toggle-off'"></i>
        </button>
      </div>

      <div class="form-group col-sm-1 random-sample-calls" *ngIf="mode == 'agent'">
        <ng-container *ngIf="filter.RandomSampleEnabled">
          <label>Number of calls</label>
          <input
            type="number"
            class="form-control form-control-sm"
            [(ngModel)]="filter.RandomSampleCallCount"
            name="randomSampleCallCount"
            min="1"
            max="50"
            [disabled]="disabled || !filter.RandomSampleEnabled"
          />
        </ng-container>
      </div>

      <div class="form-group col-sm-2">
        <button class="button ND--buttons--second-button btn-search" [disabled]="disabled || form.invalid" (click)="resetFilter()">
          Reset
        </button>
        <button class="button ND--buttons--primary btn-search" [disabled]="disabled || form.invalid" (click)="searchClick()">Select</button>
      </div>
    </div>
  </form>
</div>
